package game.entity

import game.Game
import game.Room
import game.TileType
import kotlin.random.Random

class Hunter(hp: Int, damage: Int, val spriteId: String): Enemy(hp, damage) {
    val wanderComponent = WanderComponent(4, false, TileType.Floor)
    var attackCoolDown = getAttackDuration()

    private fun getAttackDuration() = Random.nextInt(100, 150)
    private val projectile = Projectile(0.3, 1, damage, false)

    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById(spriteId)
    }

    override fun onTick(game: Game, room: Room) {
        wanderComponent.tick(game, room, this)

        attackCoolDown--
        if (attackCoolDown == 0) {
            attackCoolDown = getAttackDuration()

            val projectileSpriteId = when {
                wanderComponent.colVel == -1 -> "arrow-left"
                wanderComponent.colVel == 1 -> "arrow-right"
                wanderComponent.rowVel == -1 -> "arrow-up"
                else -> "arrow-down"  // SHOULD be rowVel==1
            }
            room.addEntity(projectile)
            projectile.startAttack(game, col, row, col + wanderComponent.colVel, row + wanderComponent.rowVel, projectileSpriteId)
        }
    }
}